/**
 * Unified enum for all search input types
 * Used for both input detection and suggestion types
 */
export enum SearchInputType {
  /** Coordinate input: lat,lng or lng,lat format */
  COORDINATE = "coordinate",

  /** WKT Geometry input: POINT, POLYGON, etc. */
  WKT_GEOMETRY = "wkt_geometry",

  /** Google Places address that matches autocomplete results */
  GOOGLE_PLACE = "google_place",

  /** Plain text search for backend query */
  TEXT = "text",
}
